import { FC, useContext, useState } from 'react';
import Chip from '@mui/material/Chip';
import { Dialog } from 'components/Dialogs';
import ValuationContext from 'pages/ValuationsAllocation/ValuationContext';
import { EffectiveTaxRateChipProps } from './types';
import { DCF_TEST_IDS } from '../../DiscountCashFlow.testIds';
import EffectiveTaxRateLedger from '../EffectiveTaxRateLedger';

const EffectiveTaxRateChip: FC<EffectiveTaxRateChipProps> = props => {
  const { cashTaxRate, isDisabled } = props;
  const { measurementDate, setCashTaxRate, companyMeasurementDate } = useContext(ValuationContext);
  const [showLedger, setShowLedger] = useState(false);
  const handleClick = () => {
    setShowLedger(true);
  };

  const onClose = () => {
    setShowLedger(false);
  };

  return (
    <>
      <Chip
        data-testid={DCF_TEST_IDS.taxRateChip}
        className="effective-tax-rate-chip"
        label={`${(Number(cashTaxRate?.effective_tax_rate ?? 0) * 100).toFixed(1)}%`}
        clickable
        color="secondary"
        size="small"
        onClick={handleClick}
        variant="outlined"
      />
      {showLedger && (
        <Dialog onClose={onClose} open={showLedger} hideTitle>
          <EffectiveTaxRateLedger
            cashTaxRate={cashTaxRate}
            closeDialog={onClose}
            companyMeasurementDate={companyMeasurementDate}
            isDisabled={isDisabled}
            measurementDate={measurementDate}
            setCashTaxRate={setCashTaxRate ?? (() => {})}
          />
        </Dialog>
      )}
    </>
  );
};

export default EffectiveTaxRateChip;
